import React from 'react';
import FormikDownshiftComplete from '../dropdowns/FormikDownshiftComplete';
import HintText from 'components/labels/HintText';
import ButtonStatus from 'components/buttons/ButtonStatus';
import { Field } from 'formik';

// component
export function FormDownshiftComplete({ addButtonTitle, onAdd, dataSource, ...others }) {
  return (
    <Field
      component={FormikDownshiftComplete}
      dataSource={dataSource}
      noOptionsNode={(mySearchTerm) => {
        return (
          <div>
            <div>
              <HintText>{`Nenhum resultado.${
                mySearchTerm.trim().length === 0 && dataSource.length > 0 ? ' Digite para buscar...' : ''
              }`}</HintText>
            </div>

            <div style={{ marginTop: '10px' }}>
              <ButtonStatus
                status="success"
                size="small"
                onClick={() => {
                  onAdd(mySearchTerm);
                }}
                variant="contained"
                fullWidth
              >
                {addButtonTitle}
              </ButtonStatus>
            </div>
          </div>
        );
      }}
      {...others}
    />
  );
}
